import React from 'react';
import Slider from 'react-slick';
import { useTranslation } from 'react-i18next';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import oneDayExcursion from '../assets/Excursion/site_0450_0020-1200-630-20151105154018.jpg';
import twoDaysExcursion from '../assets/Excursion/The+Common+Wanderer-9888.jpg';
import threeDaysExcursion from '../assets/Excursion/1288609237.webp';
import fourDaysExcursion from '../assets/Excursion/historical-background-in-nuwara-eliya.jpg';
import twentyDaysExcursion from '../assets/Excursion/historical-background-in-nuwara-eliya.jpg';
import bentotaToElla1 from '../assets/Excursion/beauty-at-bentota-beach.jpg';
import bentotaToElla2 from '../assets/Excursion/bentota-beach-sri-lanka.jpg';
import airportToColombo1 from '../assets/Excursion/GettyImages-1094984028-b10df220e87d4bedb7b6ecf7c7e6ff40.jpg';
import airportToColombo2 from '../assets/Excursion/Colombo-Bandaranaike-International-Airport.jpg.webp';

const Excursions = () => {
    const { t } = useTranslation();

    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        pauseOnHover: true,
        cssEase: 'ease-in-out',
        appendDots: (dots) => (
            <div>
                <ul className="flex justify-center space-x-2">{dots}</ul>
            </div>
        ),
        customPaging: () => (
            <div className="w-3 h-3 bg-gray-300 rounded-full hover:bg-[#C58E2F] transition"></div>
        ),
        responsive: [
            {
                breakpoint: 1280,
                settings: { slidesToShow: 3 },
            },
            {
                breakpoint: 1024,
                settings: { slidesToShow: 2 },
            },
            {
                breakpoint: 768,
                settings: { slidesToShow: 1 },
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '10px',
                },
            },
        ],
    };

    const excursions = [
        {
            image: oneDayExcursion,
            title: t('excursionsSection.excursions.oneDay.title'),
            description: t('excursionsSection.excursions.oneDay.description'),
            alt: t('excursionsSection.excursions.oneDay.alt'),
        },
        {
            image: twoDaysExcursion,
            title: t('excursionsSection.excursions.twoDays.title'),
            description: t('excursionsSection.excursions.twoDays.description'),
            alt: t('excursionsSection.excursions.twoDays.alt'),
        },
        {
            image: threeDaysExcursion,
            title: t('excursionsSection.excursions.threeDays.title'),
            description: t('excursionsSection.excursions.threeDays.description'),
            alt: t('excursionsSection.excursions.threeDays.alt'),
        },
        {
            image: fourDaysExcursion,
            title: t('excursionsSection.excursions.fourDays.title'),
            description: t('excursionsSection.excursions.fourDays.description'),
            alt: t('excursionsSection.excursions.fourDays.alt'),
        },
        {
            image: twentyDaysExcursion,
            title: t('excursionsSection.excursions.twentyDays.title'),
            description: t('excursionsSection.excursions.twentyDays.description'),
            alt: t('excursionsSection.excursions.twentyDays.alt'),
        },
    ];

    const bentotaExcursions = [
        {
            number: '01',
            title: t('excursionsSection.bentotaExcursions.bentotaToYala.title'),
            description: t('excursionsSection.bentotaExcursions.bentotaToYala.description'),
        },
        {
            number: '02',
            title: t('excursionsSection.bentotaExcursions.bentotaToNuwaraEliya.title'),
            description: t('excursionsSection.bentotaExcursions.bentotaToNuwaraEliya.description'),
        },
        {
            number: '03',
            title: t('excursionsSection.bentotaExcursions.bentotaToMinneriya.title'),
            description: t('excursionsSection.bentotaExcursions.bentotaToMinneriya.description'),
        },
        {
            number: '04',
            title: t('excursionsSection.bentotaExcursions.bentotaToHortonPlains.title'),
            description: t('excursionsSection.bentotaExcursions.bentotaToHortonPlains.description'),
        },
    ];

    const airportExcursions = [
        {
            number: '01',
            title: t('excursionsSection.airportExcursions.airportToColombo.title'),
            description: t('excursionsSection.airportExcursions.airportToColombo.description'),
            alt1: t('excursionsSection.airportExcursions.airportToColombo.alt1'),
            alt2: t('excursionsSection.airportExcursions.airportToColombo.alt2'),
        },
        {
            number: '02',
            title: t('excursionsSection.airportExcursions.airportToSigiriya.title'),
            description: t('excursionsSection.airportExcursions.airportToSigiriya.description'),
            alt1: t('excursionsSection.airportExcursions.airportToSigiriya.alt1'),
            alt2: t('excursionsSection.airportExcursions.airportToSigiriya.alt2'),
        },
        {
            number: '03',
            title: t('excursionsSection.airportExcursions.airportToKandy.title'),
            description: t('excursionsSection.airportExcursions.airportToKandy.description'),
            alt1: t('excursionsSection.airportExcursions.airportToKandy.alt1'),
            alt2: t('excursionsSection.airportExcursions.airportToKandy.alt2'),
        },
        {
            number: '04',
            title: t('excursionsSection.airportExcursions.airportToGalle.title'),
            description: t('excursionsSection.airportExcursions.airportToGalle.description'),
            alt1: t('excursionsSection.airportExcursions.airportToGalle.alt1'),
            alt2: t('excursionsSection.airportExcursions.airportToGalle.alt2'),
        },
    ];

    return (
        <div className="py-16 px-4 sm:px-8 lg:px-16 bg-gradient-to-b from-[#FFFFFF] to-[#F8F1E9] min-h-screen font-customFont">
            {/* Custom Styles for Slider Arrows */}
            <style jsx>{`
                .slick-prev,
                .slick-next {
                    width: 48px;
                    height: 48px;
                    background-color: #C58E2F;
                    border-radius: 50%;
                    display: flex !important;
                    align-items: center;
                    justify-content: center;
                    z-index: 10;
                    transition: background-color 0.3s ease-in-out, transform 0.3s ease-in-out;
                    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
                }
                .slick-prev:hover,
                .slick-next:hover {
                    background-color: #A57324;
                    transform: scale(1.1);
                }
                .slick-prev:before,
                .slick-next:before {
                    font-size: 28px;
                    color: #FFFFFF;
                }
                @media (max-width: 640px) {
                    .slick-prev,
                    .slick-next {
                        width: 40px;
                        height: 40px;
                    }
                    .slick-prev:before,
                    .slick-next:before {
                        font-size: 24px;
                    }
                    .slick-slide {
                        padding: 0 10px;
                    }
                }
            `}</style>

            {/* Excursions Section with Slider */}
            <div className="max-w-7xl mx-auto">
                <h2 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-center text-[#122C56] mb-12 tracking-tight drop-shadow-md animate-fade-in">
                    {t('excursionsSection.title')}
                </h2>
                <Slider {...sliderSettings} className="px-4">
                    {excursions.map((excursion, index) => (
                        <div key={index} className="px-3">
                            <div className="bg-white rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transform transition-all duration-500 hover:scale-105 group">
                                <div className="relative overflow-hidden">
                                    <img
                                        src={excursion.image}
                                        alt={excursion.alt}
                                        className="w-full h-56 sm:h-64 md:h-72 object-cover transition-transform duration-500 group-hover:scale-110"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-[#122C56] to-transparent opacity-0 group-hover:opacity-70 transition-opacity duration-300"></div>
                                </div>
                                <div className="p-6 bg-[#F8F1E9] border-t-2 border-[#C58E2F]">
                                    <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-[#122C56] mb-2">
                                        {excursion.title}
                                    </h3>
                                    <p className="text-gray-700 text-sm sm:text-base line-clamp-3">
                                        {excursion.description}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>

            {/* Excursions from Bentota Section */}
            <div className="max-w-7xl mx-auto mt-16">
                <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-center text-[#122C56] mb-12 tracking-tight drop-shadow-md animate-fade-in">
                    {t('excursionsSection.bentotaExcursions.title')}
                </h2>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
                    {/* Left Column: Styled Descriptions */}
                    <div className="space-y-8">
                        {bentotaExcursions.map((excursion, index) => (
                            <div key={index} className="flex items-start bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
                                <span className="text-3xl sm:text-4xl font-bold text-[#C58E2F] mr-4">
                                    {excursion.number}
                                </span>
                                <div>
                                    <h3 className="text-xl sm:text-2xl font-bold text-[#122C56] mb-2">
                                        {excursion.title}
                                    </h3>
                                    <p className="text-gray-700 text-sm sm:text-base">
                                        {excursion.description}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Right Column: Stacked Images */}
                    <div className="relative flex flex-col md:block lg:mr-8">
                        <div className="relative overflow-hidden rounded-2xl shadow-xl group">
                            <img
                                src={bentotaToElla1}
                                alt={t('excursionsSection.bentotaExcursions.images.bentotaToElla1')}
                                className="w-full h-64 sm:h-80 md:h-96 object-cover transition-transform duration-500 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-[#122C56] to-transparent opacity-0 group-hover:opacity-70 transition-opacity duration-300"></div>
                        </div>
                        <div className="relative overflow-hidden rounded-2xl shadow-xl group mt-4 md:mt-0 md:absolute md:top-20 md:left-10">
                            <img
                                src={bentotaToElla2}
                                alt={t('excursionsSection.bentotaExcursions.images.bentotaToElla2')}
                                className="w-full h-64 sm:h-80 md:h-96 object-cover transition-transform duration-500 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-[#122C56] to-transparent opacity-0 group-hover:opacity-70 transition-opacity duration-300"></div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Excursions from Airport Section */}
            <div className="max-w-7xl mx-auto mt-16">
                <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-center text-[#122C56] mb-12 tracking-tight drop-shadow-md animate-fade-in">
                    {t('excursionsSection.airportExcursions.title')}
                </h2>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
                    {/* Left Column: Styled Descriptions */}
                    <div className="space-y-8">
                        {airportExcursions.map((excursion, index) => (
                            <div key={index} className="flex items-start bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
                                <span className="text-3xl sm:text-4xl font-bold text-[#C58E2F] mr-4">
                                    {excursion.number}
                                </span>
                                <div>
                                    <h3 className="text-xl sm:text-2xl font-bold text-[#122C56] mb-2">
                                        {excursion.title}
                                    </h3>
                                    <p className="text-gray-700 text-sm sm:text-base">
                                        {excursion.description}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Right Column: Stacked Images */}
                    <div className="relative flex flex-col md:block lg:mr-8">
                        <div className="relative overflow-hidden rounded-2xl shadow-xl group">
                            <img
                                src={airportToColombo1}
                                alt={airportExcursions[0].alt1}
                                className="w-full h-64 sm:h-80 md:h-96 object-cover transition-transform duration-500 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-[#122C56] to-transparent opacity-0 group-hover:opacity-70 transition-opacity duration-300"></div>
                        </div>
                        <div className="relative overflow-hidden rounded-2xl shadow-xl group mt-4 md:mt-0 md:absolute md:top-20 md:left-10">
                            <img
                                src={airportToColombo2}
                                alt={airportExcursions[0].alt2}
                                className="w-full h-64 sm:h-80 md:h-96 object-cover transition-transform duration-500 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-[#122C56] to-transparent opacity-0 group-hover:opacity-70 transition-opacity duration-300"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Excursions;